import React, { useEffect, useRef, useState } from 'react'
import { useSelector } from 'react-redux';
import dayjs from 'dayjs';
import { useNavigate, useParams } from 'react-router-dom';
import { getAllEmployees, getBusinessHours, getStoreAnalysis, getSubscriptions } from '../../utils/firebase/firestore';
import { Card, CardContent, CardHeader, Grid, Paper, TextField, Typography } from '@mui/material';
import LoadingPage from '../../components/common/loading';
import BusinessTable from '../../components/Tables/BasicTable';
import SubscriptionsTable from '../../components/Tables/subsTable';
import EmpsTable from '../../components/Tables/CustomTable';
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs';
import { LocalizationProvider } from '@mui/x-date-pickers/LocalizationProvider';
import { DatePicker } from '@mui/x-date-pickers/DatePicker';

import PageToggle from '../../components/common/PageToggle';
import { mainColor } from '../../constants';
import EmailImage from "../../assets/email.svg"
import { getDocById, updateItem } from '../../utils/firebase/dynamic';
import ReportsSection from './reportsSection';
import { Timestamp } from 'firebase/firestore';
import { current } from '@reduxjs/toolkit';
import ServerError from '../../components/common/serverError';
const MerchantDetails = () => {
  const { id } = useParams();
  const stores = useSelector(state => state.store.stores);
  const store = useRef();
  const navigate = useNavigate();
  const [subsSearch, setSubSearch] = useState("")
  const [switchCase, changeSwitch] = useState("o")//o,p,r
  const [storeAnalysis, setAnaylsis] = useState('');
  const [usedMinutes, setUsedminutes] = useState({ used: 0, total: 0 });
  const [exist, setExist] = useState(false)
  const [isloading, setIsloading] = useState(true);
  const [activePlan, setActive] = useState(null);
  const [prevPlan, setPrevPlan] = useState(null);//chargeId
  const [inTrial, setTrial] = useState(false);
  const [saveMState, setSavedMState] = useState({ visible: false, success: true, msg: "" });
  const [saveTrialState, setTrialState] = useState({ visible: false, success: true, msg: "" });
  const [saveMLod, setSaveMLoad] = useState(false);
  const [saveFLod, setSaveFLoad] = useState(false);
  const [minutechange, setMinuteCahnge] = useState(false);
  const [totalSubs, setTotalSubs] = useState(0);
  const [sectionErr, setSectionErr] = useState({
    overview: false,
    plans: false,
    analysis: false,
  })
  const current = useRef(new Date()).current
  current.setDate(current.getDate() + 1)
  const [trialDate, setTrialDate] = useState({
    old: null,
    new: null,
    min: dayjs(current)
  });
  const [subscriptions, setSubscribtions] = useState([])
  const [minutes, setMinutes] = useState({
    value: 0,
    err: ""
  })
  const [subs, setSubs] = useState({
    rows: [], header: []
  })
  const [emps, setEmps] = useState({
    rows: [], header: []
  })
  const [bHours, setBhours] = useState({
    rows: [], header: []
  })

  const checkTrial = (endTrialDate) => {
    const store = (stores || []).filter(store => store?.name === id)[0];
    const diff = new Date(endTrialDate).getTime() > (new Date().getTime());
    const current = new Date()
    current.setDate(current.getDate() + 1)
    setTrialDate({
      old: new Date(endTrialDate),
      new: null,
      min: diff ? dayjs(new Date(endTrialDate)) : dayjs(current)
    })
    if (diff) {

      setTrial(true);
    }
  }
  const handleAdjustFree = async () => {

    setTrialState({
      msg: '',
      visible: false,
      success: false,
    })
    if (!trialDate.new.format()) return
    setSaveFLoad(true)
    // return setTrialState({
    //   msg: `Successfuly Saved your data.✅`,
    //   visible: true,
    //   success: true,
    // })
    const isUpdated = await updateItem("stores", id, { endTrialDate: Timestamp.fromDate(new Date(trialDate.new.format())) })
    if (isUpdated) {
      setTrialState({
        msg: `Successfuly Saved your data.✅`,
        visible: true,
        success: true,
      })

      setTimeout(() => {
        setTrialState({
          msg: '',
          visible: false,
          success: false,
        })
        setMinuteCahnge(s => !s)
      }, 2000);
    } else {
      setTrialState({
        msg: `Something Went wrong, Failed to save your data.❌ `,
        visible: true,
        success: false,
      })
    }
    setSaveFLoad(false)

  }
  const handleAdjustMinutes = async () => {
    setSavedMState({
      msg: '',
      visible: false,
      success: false,
    })
    if (+minutes.value < +usedMinutes.used) return setSavedMState({
      msg: `Can't be less than merchant's used Minutes(${usedMinutes.used})`,
      visible: true,
      success: false,
    })
    setSaveMLoad(true);
    const isAdded = await updateItem("stores", id, { numberOfMinute: +minutes.value });
    if (isAdded) {
      setSavedMState({
        msg: `Successfuly Saved your data.✅`,
        visible: true,
        success: true,
      })
      setTimeout(() => {
        setSavedMState({
          msg: '',
          visible: false,
          success: false,
        })
        setMinuteCahnge(s => !s)
        // window.location.reload()
      }, 2000);
    } else {
      setSavedMState({
        msg: `Something Went wrong, Failed to save your data.❌ `,
        visible: true,
        success: false,
      })
    }
    setSaveMLoad(false);
  }
  const handleMinutesChange = (text) => {
    if (Number(text).toString() === "NaN") {
      return setMinutes((p) => ({
        ...p,
        // value: text,
        err: "Must be a number",
      }));
    }

    // if(text.length<7){
    setMinutes({
      err: "",
      value: text
    })
    // }
  }
  useEffect(() => {
    let unsub
    (async () => {
      const isExist = (stores || []).filter(store => store.name === id);
      store.current = isExist[0] || null
      if (isExist.length > 0) {

        unsub = await getStoreAnalysis(id, setAnaylsis, setSectionErr);
        // checkTrial()
        setExist(true)
      } else {
        setExist(false);
      }
      setIsloading(false)
    })()
    return () => {
      if (unsub) unsub()
    }
  }, [])
  //section overview
  const overviewCheck = async () => {
    const { data: hours, error: bErr } = await getBusinessHours(id);
    if (bErr) return setSectionErr(p => ({
      ...p,
      overview: true
    }))
    const hoursFormat = formatHours(hours);
    setBhours(hoursFormat);
    //
    const { data, error } = await getAllEmployees(id);
    if (error) return setSectionErr(p => ({
      ...p,
      overview: true
    }))
    const empFormat = formatEmps(data);
    setEmps(empFormat)
  }
  useEffect(() => {
    exist && (async () => await overviewCheck())()
  }, [exist])
  //section plans
  const plansCheck = async () => {
    const { data, error } = await getDocById('stores', id);
    if (error) return setSectionErr(p => ({
      ...p,
      plans: true
    }))
    data && setUsedminutes({
      total: data.numberOfMinute,
      used: data.numberOfMinutesUsed || 0
    })
    setMinutes({ value: data.numberOfMinute, err: "" })
    checkTrial(data.endTrialDate.toDate())

    //
    const { data: subs, error: subsErr } = await getSubscriptions(id)
    if (subsErr) return setSectionErr(p => ({
      ...p,
      plans: true
    }))
    // console.log("subs", subs)
    subs?.length && getTotalSubs(subs)
    const activeSub = subs?.length > 0 ?
      subs.filter(s => s?.statusSubscription == "active")[0] || null : null;
    setSubscribtions(subs || [])
    setActive(activeSub);
    const subsformat = formatSubs(subs);
    setSubs(subsformat);
    setPrevPlan(data?.prevSubscriptionId)
  }
  useEffect(() => {
    exist && id && (async () => await plansCheck())()
  }, [exist, minutechange, id])
  const formatEmps = (data) => {
    const header = ["Profile picture", "Name", "Email"];
    if (!data.length) return { rows: [], header }
    const rows = [];
    for (let emp of data) {
      rows.push([
        emp.profile_picture,
        emp.first_name + " " + emp.last_name,
        emp.email,
      ])
    }
    return { rows, header };
  }
  const formatSubs = (data) => {
    const header = ["Charge Id", "Name", "Status", "Start Date", "Cancel Date", "Total"]
    let rows = []
    for (let sub of data) {
      rows.push([
        sub.id,
        sub.plan.title,
        sub.statusSubscription,
        new Date(sub.created_at).toLocaleDateString(),
        sub.statusSubscription.toLowerCase() == "active" ? "currently running" : sub.dateCanceled?.toDate().toLocaleDateString(),
        "$" + (sub.dateSubscription.length * +sub.plan.pricePlan).toLocaleString('en-US'),
      ])
    }
    const compare = (a, b) => new Date(b[3]).getTime() - new Date(a[3]).getTime();

    rows = rows.sort(compare)
    return { rows, header }
  }
  const formatHours = (data) => {
    const header = ["Day", "Start Time", "End Time", "Is Full Day?", "Is Open?"];
    const days = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"]
    const rows = [];
    for (let day of data) {
      let start = day.slot.length ? day.slot.map(i => {
        let hour = i.start.toDate().getHours()
        if (hour < 10) hour = `0${hour}`
        let minutes = i.start.toDate().getMinutes()
        if (minutes < 10) minutes = `0${minutes}`;
        return hour + ":" + minutes
      }) : "Not specified";
      Array.isArray(start) && start.sort()
      let end = day.slot.length ? day.slot.map(i => {
        let hour = i.end.toDate().getHours()
        if (hour < 10) hour = `0${hour}`
        let minutes = i.end.toDate().getMinutes()
        if (minutes < 10) minutes = `0${minutes}`;
        return hour + ":" + minutes
      }) : "Not specified";
      Array.isArray(end) && end.sort()
      rows.push([
        days[day.index],
        day.isFullDay ? "Not specified" : start,
        day.isFullDay ? "Not specified" : end,
        day.isFullDay ? "Yes" : "No",
        day.open ? "Yes" : "No"
      ])
    }

    return { rows, header }
  }
  const getTotalSubs = (subs) => {
    // if(!subs.length>0) return 0;
    let total = 0
    for (let sub of subs) {
      total += (sub.dateSubscription.length) * +sub.plan.pricePlan
    }
    setTotalSubs(total)
  }

  const AdjustMinutes = switchCase == "p" && !sectionErr.plans && (<div>
    <Card style={{
      marginBottom: 20
    }}>
      <CardHeader
        title={"Control their minutes"}
      />
      <CardContent>
        <Typography variant="body1" color={"GrayText"}>Adjust merchant minutes. add or discard from them</Typography>
        <div style={{
          display: "flex",
          alignItems: 'center',
          marginTop: 20,
        }}>
          {/* <div style={{ marginRight: 20, width: "100%", height: 70 }}> */}
          <TextField
            id="minute"
            label="Minute"
            placeholder="Bundle price"
            type="text"
            fullWidth
            onChange={(e) =>
              handleMinutesChange(e.target.value)
            }
            value={minutes.value}
            helperText={minutes.err}
            required
          />
          {/* </div> */}
          <button style={{
            width: 200,
            height: 50,
            marginLeft: 30,
            backgroundColor: usedMinutes.total === +minutes.value ? "lightGray" : "green",
            color: "white",
            border: 0,
            borderRadius: 5,
            cursor: usedMinutes.total === +minutes.value ? "default" : "pointer",

          }}
            disabled={!minutes.value || usedMinutes.total === +minutes.value}
            onClick={async () => await handleAdjustMinutes()}
          >
            {saveMLod ? "Loading..." : "Adjust"}
          </button>
          <button style={{
            width: 200,
            height: 50,
            marginLeft: 30,
            backgroundColor: usedMinutes.total === +minutes.value ? "lightGray" : "#5847ce",
            color: "white",
            border: 0,
            borderRadius: 5,
            cursor: usedMinutes.total === +minutes.value ? "default" : "pointer",

          }}
            onClick={() => {
              setMinutes({ value: usedMinutes.total, err: "" })
              setSavedMState({
                visible: false,
                msg: "",
                success: true
              })
            }}
          >
            {"Cancell"}
          </button>
        </div>
        <p style={{
          fontSize: 14,
          color: saveMState.success ? "green" : "red"
        }}>{saveMState.msg}</p>
      </CardContent>
    </Card>
  </div>)

  const adjustFreeTrial = switchCase == "p" && !sectionErr.plans && trialDate.old && (<div>
    <Card style={{
      marginBottom: 20
    }}>
      <CardHeader
        title={"Control their Free Trial"}
      />
      <CardContent>
        <Typography variant="body1" color={"black"}>Adjust merchant free Trial,Extend their free trial end date.</Typography>
        <Typography variant='body1' color={"black"}>Current End Date: <Typography variant="body2" color={"GrayText"} component={"span"}>{trialDate.old.toLocaleDateString()}</Typography></Typography>
        <div style={{
          display: "flex",
          alignItems: 'center',
          marginTop: 20,
        }}>
          {/* <div style={{ marginRight: 20, width: "100%", height: 70 }}> */}
          <LocalizationProvider dateAdapter={AdapterDayjs}>
            {/*  */}
            <DatePicker minDate={trialDate.min} value={trialDate.new} onChange={(newValue) => {
              setTrialDate(p => ({
                ...p,
                new: newValue
              }))
            }} />

          </LocalizationProvider>
          {/* </div> */}
          <button style={{
            width: 200,
            height: 50,
            marginLeft: 30,
            backgroundColor: trialDate.new === null ? "lightGray" : mainColor,
            color: "white",
            border: 0,
            borderRadius: 5,
            cursor: trialDate.new === null ? "default" : "pointer",

          }}
            disabled={trialDate.new === null}
            onClick={async () => await handleAdjustFree()}
          >
            {saveFLod ? "Loading..." : "Change Date"}
          </button>
          <button style={{
            width: 200,
            height: 50,
            marginLeft: 30,
            backgroundColor: trialDate.new === null ? "lightGray" : "white",
            color: trialDate.new === null ? "white" : "blue",
            border: trialDate.new === null ? "0px" : "1px solid blue",

            borderRadius: 5,
            cursor: trialDate.new === null ? "default" : "pointer",

          }}
            onClick={() => {
              setTrialState({
                visible: false,
                msg: "",
                success: true
              })
              setTrialDate(p => ({
                ...p,
                new: null
              }))
            }}
          >
            {"Cancell"}
          </button>
        </div>
        <p style={{
          fontSize: 14,
          color: saveTrialState.success ? "green" : "red"
        }}>{saveTrialState.msg}</p>
      </CardContent>
    </Card>
  </div>)
  if (isloading) return <LoadingPage />
  if (!exist) {
    navigate('/merchants');
    return null;
  }
  return (
    !isloading && exist && id && <div style={{
      display: "flex",
      justifyContent: "center",
      alignItems: "center",
      flexDirection: 'column',
      marginTop: 20
    }} >
      <div style={{
        width: "90%",
        display: "flex",
        flexDirection: "column",
        // alignItems:"center",
        justifyContent: "space-between",
        margin: "10px 0px",
        backgroundColor: "white",
        padding: "20px 0px 0px 10px"
      }}>
        <Typography variant="h6" style={{ fontSize: 30 }}>{id}</Typography>
        <div style={{ display: "flex", margin: "20px 0px 0px 10px" }}>
          <div
            onClick={() => {
              changeSwitch("o");
            }}
            className="analytics-header"
            style={{
              // color:"white",
              // borderRadius:10,
              marginRight: 20,
              display: "flex",
              width: 100,
              alignItems: "center",
              cursor: "pointer",
              paddingBottom: 10,
              borderBottom: switchCase == "o" && "3px solid",
              borderBottomColor: switchCase == "o" && "#3980FD",
              // backgroundColor:switchCase=="products"&&"#2399e6",
              color: switchCase == "o" && "#3980FD",
            }}
          >
            {/* <img width={30} height={30} src='../assets/box.png' /> */}
            {/* <FontAwesomeIcon icon={faCube} size='2x' color={switchCase=='products'?"#3980FD":'gray'}/> */}
            <p style={{ fontSize: 18, fontWeight: "600", }}>
              {"Overview"}
            </p>
          </div>
          <div
            onClick={() => {
              changeSwitch("p")
            }}
            className="analytics-header"
            style={{
              borderBottom: switchCase == "p" && "3px solid",
              borderBottomColor: switchCase == "p" && "#3980FD",
              marginRight: 20,
              display: "flex",
              width: 130,
              alignItems: "center",
              cursor: "pointer",
              paddingBottom: 10,
              // backgroundColor:switchCase=="minutes"&&"#2399e6",
              color: switchCase == "p" && "#3980FD",
            }}
          >
            {/* <FontAwesomeIcon icon={faClock} size='2x' color={switchCase=='minutes'?"#3980FD":'gray'} /> */}
            <p style={{ fontSize: 18, fontWeight: "600", }}>
              Plans & Billings
            </p>
          </div>
          <div
            onClick={() => {
              changeSwitch("r");
            }}
            className="analytics-header"
            style={{
              // color:"white",
              // borderRadius:10,
              marginRight: 20,
              display: "flex",
              width: 180,
              whiteSpace: "nowrap",
              alignItems: "center",
              cursor: "pointer",
              paddingBottom: 10,
              borderBottom: switchCase == "r" && "3px solid",
              borderBottomColor: switchCase == "r" && "#3980FD",
              // backgroundColor:switchCase=="products"&&"#2399e6",
              color: switchCase == "r" && "#3980FD",
            }}
          >
            {/* <img width={30} height={30} src='../assets/box.png' /> */}
            {/* <FontAwesomeIcon icon={faCube} size='2x' color={switchCase=='products'?"#3980FD":'gray'}/> */}
            <p style={{ fontSize: 18, fontWeight: "600", }}>
              {"Reports & Analysis"}
            </p>
          </div>
        </div>
      </div>
      <div style={{
        width: "90%",
      }} >
        {switchCase == "p" && !sectionErr.plans && <Card style={{
          marginBottom: 20
        }}>
          {/* <CardHeader
              // title={<strong>{`${id}'s Minutes`}</strong>} 
            /> */}
          <CardContent>
            <div style={{
              display: "flex",
              alignItems: "center",
              fontSize: 20
            }}>
              {/* <Typography variant="subtitle2" color='black' >Total Minutes:&nbsp;</Typography> <Typography variant="body1" color="text.secondary">{storeAnalysis.totalMinutes||usedMinutes.total}</Typography> */}
              <div style={{
                padding: 5,
                backgroundColor: mainColor,
                color: "white",
                minWidth: "100px",
                borderRadius: 6,
                marginRight: 5
              }} ><p>{activePlan ? activePlan?.plan?.title : prevPlan ? (subscriptions || []).filter(s => s.id == prevPlan)[0].plan?.title : "Free Trial"}</p></div>
            </div>
            <div style={{
              display: "flex",
              marginTop: "10px",
              alignItems: "center"
            }}>
              <Typography variant="h6" color='text.secondary' > Status:&nbsp;</Typography>
              <Typography variant="h6" color="black">{activePlan ? "Active" : inTrial ? "Active" : prevPlan ? "Cancelled" : "Finished"}</Typography>
            </div>
            {activePlan && <div style={{
              display: "flex",
              marginTop: "10px",
              alignItems: "center"
            }}>
              <Typography variant="h6" color='text.secondary' >Current plan end Period:&nbsp;</Typography>
              <Typography variant="h6" color="black">{new Date(activePlan.ends_at).toDateString()}</Typography>
            </div>}
            <div style={{
              display: "flex",
              flexDirection: "column",
              width: "100%",
              marginTop: 20,
              // marginLeft:20
            }}>
              <div style={{
                display: "flex",
                justifyContent: "space-between"
              }}>
                <p style={{
                  fontWeight: 500,
                  fontSize: 16,
                  color: "rgba(58, 53, 65, 0.87)"
                }}>Used Minutes</p>
                <p style={{
                  fontWeight: 500,
                  fontSize: 16,
                  color: "rgba(58, 53, 65, 0.87)"
                }}>{usedMinutes.used} Minutes of {usedMinutes.total}</p>
              </div>
              <div style={{
                backgroundColor: "rgb(202 194 216)",
                width: "100%",
                display: "flex",
                margin: "20px 0px 30px 0px",
                borderRadius: 5,
              }}>
                <div style={{
                  backgroundColor: "#3980FD",
                  width: `calc(${(usedMinutes.used / usedMinutes.total)} * 100%)`,
                  height: 15,
                  borderRadius: 5,
                  borderTopLeftRadius: 10, borderBottomLeftRadius: 10
                }}
                ></div>

              </div>
            </div>
          </CardContent>

        </Card>}
        {switchCase == "o" && sectionErr.overview && <ServerError />}
        {switchCase == "p" && sectionErr.plans && <ServerError />}
        {switchCase == "r" && sectionErr.analysis && <ServerError />}
        {AdjustMinutes}
        {adjustFreeTrial}
        {switchCase == "p" && !sectionErr.plans && <Card style={{
          marginBottom: 20,
        }}>
          <CardHeader title={<strong>Subscriptions History</strong>} />
          <CardContent>
            <p></p>
            {subs?.rows?.length > 0 ? <div>
              <div style={{ marginBottom: 10 }}>
                <p style={{
                  fontSize: 18,
                  fontWeight: 500,
                  color: "grey",
                }}>Total Payments:<span style={{ color: "black" }}>&nbsp;${totalSubs.toLocaleString('en-US')}</span></p>
              </div>
              <SubscriptionsTable
                setSearch={setSubSearch}
                rows={(subs?.rows && subs?.rows?.length) ? subs?.rows?.filter(row => (
                  row[0].toLowerCase().match(new RegExp(subsSearch.toLowerCase().trim())) ||
                  row[1].toLowerCase().match(new RegExp(subsSearch.toLowerCase().trim())) ||
                  row[2].toLowerCase().match(new RegExp(subsSearch.toLowerCase().trim()))
                )) : []}
                header={subs.header} />
            </div> :
              <p>There are no records of subscriptions for this store.</p>}
          </CardContent>
        </Card>}
        {switchCase == "r" && !sectionErr.analysis && <ReportsSection shopName={id} />}
      </div>
      {/* employees Data */}
      <div
        // container 
        // gap={2}
        style={{
          width: "90%",
        }}
      >

        {switchCase == "o" && !sectionErr.overview && <Card style={{
          marginBottom: 20,

        }}>
          <CardHeader title={<p style={{ fontWeight: 500, fontSize: 25 }}>{`${id}'s merchant`}</p>} />
          <CardContent>
            <div style={{
              display: "flex",
              alignItems: "center",
              marginLeft: 20
            }}>
              <img src={EmailImage} alt="email-img" />
              <p style={{
                marginLeft: 10, fontSize: 18
              }}>{store.current.email || "Not specified"}</p>
            </div>
          </CardContent>
        </Card>}
        {switchCase == "o" && !sectionErr.overview && <Card style={{
          marginBottom: 20,

        }}>
          <CardHeader title="Employees Data" />
          <CardContent>
            {emps.rows.length > 0 ?
              <EmpsTable rows={emps.rows} header={emps.header} /> :
              <p>There are no Employees at this store yet</p>
            }
          </CardContent>
        </Card>}


        {switchCase == "o" && !sectionErr.overview && <Card >
          <CardHeader title="Business Hours" />
          <CardContent>
            {bHours.rows.length && <BusinessTable rows={bHours.rows} header={bHours.header} />}
          </CardContent>
        </Card>}



      </div>

    </div>
  )
}

export default MerchantDetails